<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Potwierdzenie lokalizacji' | translate }}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <div class="flex-vertical w-100">
            <p class="warning-message">
                {{ 'COMPLAINT|UWAGA: znacznik ustawiony na podstawie częściowego dopasowania z wpisanego adresu – proszę sprawdzić czy pozycja znacznika jest poprawna, ewentualnie proszę ją skorygować lub skorygować wprowadzony adres. Ewentualny dojazd serwisu odbędzie się na podstawie znacznika!' | translate }}
            </p>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal w-100">
            <button
                iccButton
                appearance="secondary"
                (click)="close()"
            >
                {{ 'INTERFACE|Anuluj' | translate }}
            </button>
            <button
                iccButton
                appearance="primary"
                (click)="confirm()"
            >
                {{ 'COMPLAINT|Potwierdzam pozycję znacznika' | translate }}
            </button>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>
